import { LOCALE_ID } from '@angular/core';

import { HttpNoCacheBackend } from "@rx-applications/shared/utils";
import { InternationalizationService } from "./services";

export function loadLanguage(internationalizationService: InternationalizationService) {
  return internationalizationService.getLocaleId();
}

export const I18N_CONFIG_PROVIDERS = [
  HttpNoCacheBackend,
  {
    provide: LOCALE_ID,
    useFactory: loadLanguage,
    deps: [InternationalizationService],
  },
];
